// biome-ignore lint/suspicious/noExplicitAny: <explanation>
declare const window: any;

export const initializePendo = (user: { id: string; email: string; full_name: string }) => {
    if (window.pendo && user) {
        const options = {
            visitor: {
                id: user.id,
                email: user.email,
                full_name: user.full_name,
            },
            inlineStyleNonce: document
                .querySelector('meta[name="inline-nonce"]')
                ?.getAttribute('content'),
        };

        if (window.pendo.visitorId) {
            window.pendo.identify(options);
        } else {
            window.pendo.initialize(options);
        }
    }
};
